(function () {
  'use strict';
  var skip = 'script,style,noscript,textarea,input,select,option,pre,code,svg,math,template,[contenteditable="true"],[data-tah-dollar]';
  function scan(root) {
    if (!root || (root.nodeType === 1 && root.closest(skip))) return;
    var nodes = [];
    if (root.nodeType === 3) nodes.push(root);
    else {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) nodes.push(walker.currentNode);
    }
    nodes.forEach(function (node) {
      if (!node.parentElement || node.parentElement.closest(skip) || node.data.indexOf('$') < 0) return;
      var parts = node.data.split('$'), fragment = document.createDocumentFragment();
      parts.forEach(function (part, index) {
        if (index) {
          var glyph = document.createElement('span');
          glyph.setAttribute('data-tah-dollar', '');
          glyph.style.setProperty('font-family', '"TAH Continuous Dollar", sans-serif', 'important');
          glyph.textContent = '$';
          fragment.appendChild(glyph);
        }
        if (part) fragment.appendChild(document.createTextNode(part));
      });
      node.replaceWith(fragment);
    });
  }
  function start() {
    scan(document.body);
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        if (record.type === 'characterData') scan(record.target);
        else record.addedNodes.forEach(scan);
      });
    }).observe(document.body, {childList:true, subtree:true, characterData:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
